export enum AmountDisplayFormat {
    SIGN = "sign",
    COLOR = "color",
}
